import { create } from 'zustand'

export const useFiltersModalStore = create<{
  showModal: boolean
  openModal: () => void
  closeModal: () => void
  toggleModal: (payload: boolean) => void
}>(set => ({
  showModal: false,
  openModal: () => set({ showModal: true }),
  closeModal: () => set({ showModal: false }),
  toggleModal: (payload: boolean) => set({ showModal: payload })
}))
